/**
 * Collapsed width: one gutter, one icon target, one gutter. Every row in the
 * panel opens with that same icon slot, so expanding only reveals text to the
 * right of icons that never move.
 */
export const railWidth = 64

/** Expanded width — wide enough for a typical query to read before truncating. */
export const panelWidth = 300

/** Icon target inside every row, collapsed or expanded. */
export const iconSlot = 40

/** Height the brand mark holds in every state — it never resizes. */
export const brandMarkHeight = 28

// The wordmark lockup embeds the mark flush at its own left edge, 79.07 of its
// 87.98 viewBox units wide, so at `brandMarkHeight` the mark measures this.
const lockupMarkWidth = brandMarkHeight * (79.07 / 87.98)

/**
 * Nudge the lockup right by half the icon slot's slack and the mark inside it
 * lands exactly where the rail centres the standalone mark — so expanding
 * reveals the word beside a logo that hasn't moved or resized at all.
 */
export const lockupMarkInset = (iconSlot - lockupMarkWidth) / 2

/**
 * How long the width change takes. Mirrored by the CSS transition and used to
 * time the label swap, which is why it lives here rather than inline: a label
 * must never be laid out mid-change, at a width it doesn't fit.
 */
export const railTransitionMs = 220

/** Hooks for the brand slot's hover swap: the mark trades places with a chevron. */
export const sidebarClasses = {
  brandMark: 'sidebar-brand-mark',
  brandToggle: 'sidebar-brand-toggle',
}
